import ErrorSubclass from 'util/ErrorSubclass';

export class FieldNamingException extends ErrorSubclass {}

export default function nameToSqlIdentifier(
  name: string,
  validate: boolean = true,
  maxLength: number = 63
): string {
  // should be kept in sync with benchling/warehouse/naming.py:name_to_sql_identifier

  let sqlIdentifier = name.length > maxLength ? name.substring(0, maxLength) : name;
  sqlIdentifier = sqlIdentifier.toLowerCase();
  sqlIdentifier = sqlIdentifier.replace(/[^\s\-,_0-9a-z]/g, '');
  sqlIdentifier = sqlIdentifier.replace(/[\s\-,_]+/g, '_');
  sqlIdentifier = sqlIdentifier.replace(/^_+|_+$/g, '');
  if (sqlIdentifier.length > 0 && sqlIdentifier.match(/^\d.*$/)) {
    sqlIdentifier = `_${sqlIdentifier}`;
  }
  if (validate) {
    if (name.length > 0 && sqlIdentifier.length === 0) {
      throw new FieldNamingException(
        `Name "${name}" does not contain any valid characters for its system name. Explicitly set its system name or use a different viable display name.`
      );
    }
    if (sqlIdentifier.length === 0 || sqlIdentifier.length > maxLength) {
      throw new FieldNamingException(
        `Identifier "${sqlIdentifier}" must be between 1 and ${maxLength} characters`
      );
    }
    const sqlIdentifierRegex = /^[a-z_][a-z0-9_$]*$/;
    if (sqlIdentifier.match(sqlIdentifierRegex) == null) {
      throw new FieldNamingException(`Name "${sqlIdentifier}" contains illegal characters`);
    }
  }
  return sqlIdentifier;
}
